import { render, staticRenderFns } from "./direct_register.vue?vue&type=template&id=4a1288f2&scoped=true&"
import script from "./direct_register.vue?vue&type=script&lang=js&"
export * from "./direct_register.vue?vue&type=script&lang=js&"
import style0 from "./direct_register.vue?vue&type=style&index=0&id=4a1288f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1288f2",
  null
  
)

export default component.exports